import { PortalAccess } from './portal-access';

export enum enumUserStatus {
  Allocated = 1,
  Active,
  Suspended,
  Closed,
}

export namespace enumUserStatus {
  export function values() {
    return Object.keys(enumUserStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

export enum enumUserSex {
  Male = 1,
  Female,
}

export namespace enumUserSex {
  export function values() {
    return Object.keys(enumUserSex).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

export enum enumUserIdType {
  'RSA ID ' = 1,
  'Passport',
  'Business',
  'Asylum Seeker',
  'Refugee',
}

export namespace enumUserIdType {
  export function values() {
    return Object.keys(enumUserIdType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

export function userStatusToArray(): object[] {
  return Object.keys(enumUserStatus)
    .filter(
      (key) =>
        typeof enumUserStatus[key as keyof typeof enumUserStatus] === 'number'
    )
    .map((key) => ({
      id: enumUserStatus[key as keyof typeof enumUserStatus],
      itemName: key,
    }));
}

/** Match status codes from display-label or numeric partial search (mirrors Portal.UserAccess backend). 28/05/2026 PK */
export function matchUserStatusCodes(search: string): number[] {
  const term = search.trim().toLowerCase();
  if (!term) {
    return [];
  }

  const codes = new Set<number>();

  for (const { id, itemName } of userStatusToArray() as {
    id: number;
    itemName: string;
  }[]) {
    if (itemName.toLowerCase().includes(term)) {
      codes.add(id);
    }
    const codeStr = String(id);
    if (codeStr === term || codeStr.includes(term)) {
      codes.add(id);
    }
  }

  return Array.from(codes).sort((a, b) => a - b);
}

export function userSexToArray(): object[] {
  return Object.keys(enumUserSex)
    .filter(
      (key) =>
        typeof enumUserSex[key as keyof typeof enumUserSex] === 'number'
    )
    .map((key) => ({
      id: enumUserSex[key as keyof typeof enumUserSex],
      itemName: key,
    }));
}

export function userIdTypeToArray(): object[] {
  return Object.keys(enumUserIdType)
    .filter(
      (key) =>
        typeof enumUserIdType[key as keyof typeof enumUserIdType] === 'number'
    )
    .map((key) => ({
      id: enumUserIdType[key as keyof typeof enumUserIdType],
      itemName: key,
    }));
}
export interface User {
  gid: number;
  id: number;
  accessTicket: string;
  profileNo: string;
  MSISDN: string;
  firstName: string;
  lastName: string;
  identificationNo: string;
  userName: string;
  emailAddress: string;
  cellphoneNo: string;
  status: string;
  relMPortalAccess: [PortalAccess];
  recordDate: string;
  recordTime: string;
  //added new fields              25/10/24 CN
  idType: number;
  sex: number;
}
